import { Button, Image, Select, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { PayChannelItem, ChainPayProps } from "@/index";
import { usePayChannel } from "@/hooks/usePayChannel";
import { useState } from "react";
import clsx from "clsx";
import QrcodeImg from "@/assets/qrcode.png";
import CardImg from "@/assets/card.png";
import KhqrImg from "@/assets/khqr.png";
import Card1Img from "@/assets/card-1.png";
import Card2Img from "@/assets/card-2.png";
import Card3Img from "@/assets/card-3.png";
import Card4Img from "@/assets/card-4.png";

export type PayChannelProps = {
  value: string;
  code: string;
  link: string;
  iconName?: string;
  countDown: number;
  currency: string;
  orderNo: string;
  getChannelApiUrl: string;
  paymentComputed?: boolean;
};
interface SelectPayChannelProps extends ChainPayProps {
  onPayChannelChange: (data: PayChannelProps) => void;
}

async function createOrder({
  orderParams,
  appId,
  getChannelApiUrl,
}: {
  orderParams: any;
  appId: string;
  getChannelApiUrl: string;
}): Promise<string> {
  console.log(orderParams);

  return await fetch(`${getChannelApiUrl}/createOrder`, {
    method: "POST",
    headers: {
      "app-id": appId,
    },
    body: JSON.stringify(orderParams),
  }).then((res) => res.json());
}

export default function SelectPayChannel({
  appId,
  amount,
  currency,
  testApi = false,
  countDown = 10 * 60 * 1000,
  onError,
  getSignInfoFn,
  onPayChannelChange = () => {},
}: SelectPayChannelProps) {
  const { t } = useTranslation();

  const getChannelApiUrl = testApi
    ? (process as any)?.env?.testEnv?.VITE_APP_BASE_API
    : import.meta.env.DEV
    ? import.meta.env.VITE_APP_BASE_API
    : (process as any)?.env?.prodEnv?.VITE_APP_BASE_API;

  const iconAssetsPrefix = testApi
    ? (process as any)?.env?.testEnv?.VITE_APP_ICON_ASSETS_PREFIX
    : import.meta.env.DEV
    ? import.meta.env.VITE_APP_ICON_ASSETS_PREFIX
    : (process as any)?.env?.prodEnv?.VITE_APP_ICON_ASSETS_PREFIX;

  const { loading, payChannel, setPayChannel } = usePayChannel({
    appId,
    getChannelApiUrl,
  });
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  const [selectPayChannel, setSelectPayChannel] = useState<string>("");
  const [selectPayChannelSub, setSelectPayChannelSub] = useState<string>("");

  const onPaySubmit = async () => {
    let orderParams: any = {};
    if (btnLoading) return;
    if (!getSignInfoFn) return;

    const targetChannel: any = payChannel.find(
      (item: PayChannelItem) => item.name === selectPayChannel
    );
    const targetCurrency: any =
      targetChannel?.currencys?.find?.(
        (item: any) => item.currencyId === targetChannel.currency
      ) ?? {};

    setBtnLoading(true);
    try {
      const channel_pay_type =
        selectPayChannelSub === "abapay_khqr"
          ? "abapay_khqr_deeplink"
          : selectPayChannelSub;
      orderParams = await getSignInfoFn({
        amount: String(amount),
        payChannel: selectPayChannel,
        currency: targetCurrency.token,
        currencyId: targetCurrency.currencyId,
        extra: {
          channel_pay_type,
        },
      });
      if (typeof orderParams !== "object") {
        throw new Error("orderParams is not object");
      }

      const orderInfo: any = await createOrder({
        orderParams,
        appId,
        getChannelApiUrl,
      } as any);

      const { qrcode, extra, orderNo } = orderInfo?.data || {};

      if (extra.requestUrl) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = extra.requestUrl;
        form.target = "_blank";

        for (const key in extra.data) {
          if (Object.prototype.hasOwnProperty.call(extra.data, key)) {
            const value = extra.data[key];
            if (value) {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = value;
              form.appendChild(input);
            }
          }
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }

      // setBtnLoading(false);

      onPayChannelChange({
        value: selectPayChannel,
        code: qrcode,
        link:
          selectPayChannel === "huione"
            ? ""
            : selectPayChannelSub === "abapay_khqr_deeplink"
            ? extra.abapay_deeplink
            : qrcode,
        countDown: selectPayChannelSub === "cards" ? 3 * 60 * 1000 : countDown,
        currency: targetChannel.currency,
        getChannelApiUrl,
        orderNo,
      });
    } catch (error: any) {
      setBtnLoading(false);
      onError?.(error);
    }
  };

  const paywaySubList = [
    { id: "abapay_khqr_deeplink", title: `${t("Open")} Payway APP` },
    {
      id: "abapay_khqr",
      icon: QrcodeImg,
      title: t("Scan QR code"),
      subIcon: {
        width: 43,
        height: 19,
        list: [KhqrImg],
      },
    },
    {
      id: "cards",
      icon: CardImg,
      title: t("Card"),
      subIcon: {
        width: 24,
        height: 24,
        list: [Card1Img, Card2Img, Card3Img, Card4Img],
      },
    },
  ];

  return (
    <>
      <div className="flex justify-center text-[16px] font-[600] pt-[10px] text-[#3B3B3B] px-[21px]">
        {t("需支付总额")}
      </div>
      <div className="flex justify-center items-center font-[600] text-[44px] leading-none pt-[5px]">
        {amount}{" "}
        <span className="pl-[10px] pt-[5px] text-[36px]">{currency}</span>
      </div>
      <div className="flex flex-col">
        <div className="pt-[20px] text-[18px] sm:text-[14px] font-[400] text-[#7F7F7F]">
          {t("请选择支付方式")}
        </div>
        <div className="flex flex-col justify-center mt-[8px] min-h-[60px]">
          <Spin spinning={loading && !payChannel.length}>
            {!payChannel?.length && !loading && (
              <div className="text-center text-[14px] text-[#7F7F7F]">
                {t("暂未获取到支付方式")}
              </div>
            )}
            {payChannel?.map?.((item: PayChannelItem) => (
              <div
                key={item.name}
                className={clsx(
                  "flex flex-col px-[24px] sm:px-[10px] py-[12px] gap-[12px] border-[#DFDFDF] border-solid border-[1px] rounded-[12px] mb-[15px] dark:border-[rgba(255,255,255,0.3)] md:cursor-pointer",
                  {
                    "bg-[#F5F5F5]":
                      selectPayChannel === item.name && item.name !== "payway",
                    "hover:bg-[#F5F5F5]": !btnLoading && item.name !== "payway",
                  }
                )}
                onClick={() => {
                  if (btnLoading || item.name === "payway") return;
                  setSelectPayChannel(item.name);
                  setSelectPayChannelSub("");
                }}
              >
                <div className="w-full flex items-center justify-between gap-[12px]">
                  <Image
                    src={`${iconAssetsPrefix}${item.iconName}`}
                    preview={false}
                    width={36}
                  />
                  <div
                    data-font="bold"
                    className="mr-auto text-[16px] font-[700]"
                  >
                    {item.channelShowName}
                  </div>
                  <div className="flex flex-col">
                    <span className="opacity-50 text-[12px]">
                      {t("总计支付")}
                    </span>
                    <div className="flex items-center gap-[10px]">
                      <span className="font-bold">{amount}</span>
                      <Select
                        size="small"
                        className="w-[77px]"
                        value={item.currency}
                        options={item.currencys}
                        fieldNames={{ label: "token", value: "currencyId" }}
                        onChange={(value) => {
                          if (btnLoading) return;
                          setPayChannel((pre: any) => {
                            return pre.map((item: PayChannelItem) => {
                              if (item.name === selectPayChannel) {
                                item.currency = value;
                              }
                              return item;
                            });
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                {item.name === "payway" && (
                  <div className="flex flex-col">
                    {paywaySubList.map((sub) => (
                      <div
                        key={sub.id}
                        className={clsx(
                          "h-[48px] flex items-center gap-[14px] text-[14px] font-[500] text-[#3B3B3B] px-[10px] rounded-[8px]",
                          {
                            "hover:bg-[#F5F5F5]": !btnLoading,
                            "bg-[#F5F5F5]": selectPayChannelSub === sub.id,
                            "md:hidden": sub.id === "abapay_khqr_deeplink",
                          }
                        )}
                        onClick={() => {
                          if (btnLoading) return;
                          setSelectPayChannel(item.name);
                          setSelectPayChannelSub(sub.id);
                        }}
                      >
                        <Image
                          src={
                            sub.icon ?? `${iconAssetsPrefix}${item.iconName}`
                          }
                          preview={false}
                          width={20}
                        />
                        <span>{sub.title}</span>
                        <div className="ml-auto flex items-center gap-[8px]">
                          {sub.subIcon?.list?.map?.((icon) => (
                            <Image
                              key={icon}
                              src={icon}
                              preview={false}
                              width={sub.subIcon?.width}
                              height={sub.subIcon?.height}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </Spin>
        </div>
        <Button
          color="default"
          variant="solid"
          className="!mt-[18px] sm:!mt-[5px] h-[60px] sm:h-[50px] rounded-[60px] text-[24px] sm:text-[18px] font-[500]"
          loading={btnLoading}
          disabled={!btnLoading && !selectPayChannel}
          onClick={onPaySubmit}
        >
          {t("支付")}
        </Button>
        <span className="flex items-center justify-center pt-[24px] sm:pt-[10px] text-[14px] font-[500] text-[#ACACAC]">
          Powered by ChainPay
        </span>
      </div>
    </>
  );
}
